export default __webpack_public_path__ + "static/media/AUTORES_13.5243314a.png";